import TransactionPassFormErrorModel from './form-error.model';

class TransactionPassFormModel {
	constructor() {
		this.newTransactionPassword = '';
		this.confirmNewTransactionPassword = '';
		this.currentTransactionPassword = '';
		this.hasTransactionPasswordEnabled = false;

		this.error = new TransactionPassFormErrorModel();
	}

	setFormErrors(errors) {
		this.error.setFormErrors(errors);
	}

	toPayload() {
		let payload = {
			security: {
				currentTransactionPassword: this.currentTransactionPassword,
				validateCurrentTransactionPassword: this.hasTransactionPasswordEnabled,
				hasChangeTransactionPassword: true,
				transactionPassword: {
					first: this.newTransactionPassword,
					second: this.confirmNewTransactionPassword
				},
			}
		};

		return payload;
	}

	reset() {
		this.newTransactionPassword = '';
		this.confirmNewTransactionPassword = '';
		this.currentTransactionPassword = '';

		this.setFormErrors('');
	}
}

export default TransactionPassFormModel;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/transaction-authentication/transaction-pass/model/form.model.js